var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9269 29.4644V21.6073C47.9269 20.5654 47.5135 19.5661 46.7776 18.8294C46.0417 18.0926 45.0436 17.6787 44.0029 17.6787H6.7248C5.68408 17.6787 4.68599 18.0926 3.9501 18.8294C3.2142 19.5661 2.80078 20.5654 2.80078 21.6073V49.1073C2.80078 50.1492 3.2142 51.1485 3.9501 51.8852C4.68599 52.622 5.68408 53.0359 6.7248 53.0359H44.0029C45.0436 53.0359 46.0417 52.622 46.7776 51.8852C47.5135 51.1485 47.9269 50.1492 47.9269 49.1073V39.2859",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9072 7.85713L38.1564 2.04284C38.4064 1.97232 38.6681 1.95324 38.9257 1.98676C39.1833 2.02028 39.4314 2.10571 39.6551 2.23788C39.8788 2.37005 40.0734 2.54623 40.2272 2.75578C40.381 2.96534 40.4909 3.20392 40.55 3.45713L41.6488 7.85713",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8511 29.4644H42.0411C40.9575 29.4644 40.0791 30.3438 40.0791 31.4286V37.3215C40.0791 38.4063 40.9575 39.2858 42.0411 39.2858H51.8511C52.9347 39.2858 53.8132 38.4063 53.8132 37.3215V31.4286C53.8132 30.3438 52.9347 29.4644 51.8511 29.4644Z",
    stroke: "#0E5B48",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyWallet);
export default __webpack_public_path__ + "static/media/MoneyWallet.e07f7b2aa4550f5931dfcfbc44f83b8e.svg";
export { ForwardRef as ReactComponent };